import React, { useState } from 'react';
import { Send, Check } from 'lucide-react';
export function ContactFormSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="bg-brand-light p-8 rounded-xl border border-gray-200 shadow-sm" data-id="element-189">
      <h2 className="text-2xl font-bold text-brand-dark mb-6" data-id="element-190">
        Send a Message
      </h2>

      {isSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-191">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-192">
            <Check className="h-8 w-8 text-green-600" data-id="element-193" />
          </div>
          <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-194">
            Message Sent!
          </h3>
          <p className="text-green-700 mb-6" data-id="element-195">
            Thank you for contacting Precision Pro Sprayers. A member of our
            team will get back to you shortly.
          </p>
          <button onClick={() => setIsSubmitted(false)} className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide border-2 border-brand-dark text-brand-dark hover:bg-brand-light focus:ring-brand-dark h-11 px-6 text-base" data-id="element-196">
            Send Another Message
          </button>
        </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-197">
          <div className="w-full" data-id="element-198">
            <label className="block text-sm font-bold text-brand-dark mb-1" data-id="element-199">
              Name
            </label>
            <input placeholder="John Doe" required className="w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-transparent transition-all border-gray-300" data-id="element-200" />
          </div>

          <div className="w-full" data-id="element-201">
            <label className="block text-sm font-bold text-brand-dark mb-1" data-id="element-202">
              Email
            </label>
            <input type="email" placeholder="john@company.com" required className="w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-transparent transition-all border-gray-300" data-id="element-203" />
          </div>

          <div className="w-full" data-id="element-204">
            <label className="block text-sm font-bold text-brand-dark mb-1" data-id="element-205">
              Message
            </label>
            <textarea placeholder="Tell us about your needs..." required className="w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-transparent transition-all min-h-[120px] border-gray-300" data-id="element-206" />
          </div>

          <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-207">
            <Send className="w-4 h-4 mr-2" data-id="element-208" />
            Send Message
          </button>
        </form>}
    </div>;
}